var consts = {};

/**
 * Cylinder states.
 */
consts.CYLINDER_STATE = {
  CURRENT: 0,
  FULL: 1,
  PENDING: 2,
  EMPTY: 3,
  REQUESTED: 4
};

// Sensor type
consts.SENSOR_TYPE = {
  PRESSURE_SENSOR: 0,
  AIR_FLUX_SENSOR: 1,
  OXIMETER_SENSOR: 2
};

/**
 * Helper sort function to sort cylinders by it's state.
 * @param {Object} a Cylinder object.
 * @param {Object} b Cylinder object.
 */
consts.SORT_BY_STATE = function (a, b) {
  if (b.state > a.state) {
    // a is smaller than b
    return -1;
  }
  if (a.state > b.state) {
    // a is bigger than b
    return 1;
  }
  return 0;
};

// Pressure map for cylinders with volume and pressure when full
consts.CYLINDER_PRESSURE_MAP = {
  0.6: {
    v: 623,
    p: 140
  },
  1: {
    v: 1000,
    p: 140,
    c: 7
  },
  4: {
    v: 4000,
    p: 200,
    c: 20
  },
  7: {
    v: 7000,
    p: 175,
    c: 40
  },
  8: {
    v: 8000,
    p: 200,
    c: 40
  },
  10: {
    v: 10000,
    p: 200,
    c: 50
  }
};
module.exports = consts;